import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import TimeRange from 'live/components/ui/time-range'
import LIVE_PERMISSIONS from 'live/services/authorization'
import ServiceLocator from 'live/services/service-locator'
import { getMetadataComponent } from '../metadata/MetadataOptions'
import { __SOURCE_ILT__ } from '../commom'
import ILTEditionAnnotationEventForm from './ILTEditionAnnotationEventForm'
import { openModal } from '../../AnnotationModal'

const AnnotationActions = function (props) {
    const { event, onEdit, onDelete, pipesActions } = props
    // console.log('AnnotationActions props', props, event)
    const allowed = true // permissionService.canEditAnnotation(event)
    const isDraggable = !pipesActions?.__disableDragEdition
    const isEditable = !pipesActions?.__hideEditButton
    const isDeletable = !pipesActions?.__hideDeleteButton
    const isSplittable = !pipesActions?.__hideSplitButton
    // console.log("isEditable", isEditable, "isDraggable", isDraggable, "isDeletable", isDeletable, "isSplittable", isSplittable)
    const AnnotationComponent = getMetadataComponent(event.__src, event?.extra?.metadata_type)

    // console.log('AnnotationComponent', AnnotationComponent)

    return (
        <div className="live-annotation__actions">
            {allowed && isEditable && typeof onEdit === 'function' ? (
                <span onClick={() => onEdit(event, { component: AnnotationComponent })}>
                    <i className="far fa-edit" />
                </span>
            ) : null}
            {allowed && isDeletable ? (
                <span onClick={onDelete}>
                    <i className="far fa-trash-alt" />
                </span>
            ) : null}
        </div>
    )
}

const EventRenderer = props => {
    const { event, onClick, expanded, onEdit, onDelete, editing, pipesActions, mode = "temporal" } = props
    const { begin, end } = event
    console.log('EventRenderer props', props)
    const FormComponent = getMetadataComponent(event.__src, event?.extra?.metadata_type)

    return (<div>
        {editing ?
            <FormComponent {...props} /> :
            <EventRendererContainer
                onClick={expanded ? null : () => onClick(event)}
                className={`live-annotation ${expanded ? 'live-annotation--expanded' : ''}`}
            >
                <div className="live-annotation__title">
                    {`ILT: ${event?.extra?.manual_iltSubActivity ?? event?.extra?.sub_activity_name_final_event}`}
                </div>

                {expanded ? <AnnotationActions event={event} onEdit={onEdit} onDelete={onDelete} {...props} /> : null}
                <div className="live-annotation__time-range">
                    <TimeRange color={event?.__color} begin={begin} end={end} mode={mode} />
                </div>
            </EventRendererContainer>}
    </div>)
}

const EventRendererContainer = styled.div`
    color: black;

    .live-annotation__title i {
        margin-right: 4px;
    }

    .note {
        padding: 1px 5px;
        background: red;
        border-radius: 3px;
        font-size: 11px;
        color: white;
        margin-left: 5px;
        font-weight: normal;
    }
`
function eventRenderer(object) {
    if (object?.__src == __SOURCE_ILT__) {
        return {
            priority: 1,
            component: EventRenderer
        }
    }
}

const ILTFormComponent = {
    get shortTitle() {
        return i18n('ILT Annotation')
    },
    get title() {
        return i18n('Create ILT Annotation')
    },
    get editTitle() {
        return i18n('Edit ILT Annotation')
    },
    component: ILTEditionAnnotationEventForm,
    icon: "far fa-comment-alt-plus"
}

try {
    if (!window.ilt) {
        window['ilt'] = {}
    }

    window['ilt']['openILTEditionAnnotation'] = event => {
        openModal(event)
    }

    ServiceLocator.getService('timeline-event-renderer-registry').then(service => service.register(eventRenderer))
    ServiceLocator.getService('timeline-form-registry').then(reg => reg.register(ILTFormComponent))
} catch (e) {
    console.error(e)
}
